import tracking from '@finn-no/analytics';
import pulse from '@finn-no/pulse-sdk';
import * as braze from '@braze/web-sdk';

function trackClick(selector, handler) {
    const el = document.querySelector(selector);
    if (el) {
        el.addEventListener('click', handler, false);
    }
}

function round(value) {
    return Math.round(value * 100000) / 100000;
}

function addBraze() {
    const { brazeApiKey, brazeEndpointUrl, useBraze } = document.querySelector(
        '#market-frontpage-bap-header',
    ).dataset;
    if (useBraze !== 'true') return;
    braze.initialize(brazeApiKey, {
        baseUrl: brazeEndpointUrl,
    });
    braze.display.automaticallyShowNewInAppMessages();
    braze.changeUser(window.finnUserId);
    braze.openSession();
}

function getCurrentPosition() {
    return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    const coords = {
                        lat: round(pos.coords.latitude),
                        lon: round(pos.coords.longitude),
                    };
                    resolve(coords);
                },
                (e) => {
                    reject(
                        new Error(`Could not find position with error: ${e}`),
                    );
                },
                { timeout: 5000 },
            );
        } else {
            reject(new Error('Could not find position'));
        }
    });
}

function onClickClosest(event, el) {
    event.preventDefault();
    getCurrentPosition()
        .then((coords) => {
            if (coords) {
                window.location.href = `${el.href}&lat=${coords.lat}&lon=${coords.lon}`;
            } else {
                window.location.href = el.href;
            }
        })
        .catch(() => {
            window.location.href = el.href;
        });
}

function clickEventClosest(selector) {
    const el = document.querySelector(selector);
    if (el) {
        el.addEventListener(
            'click',
            (event) => onClickClosest(event, el),
            false,
        );
    }
}

function main() {
    const market = 'bap';

    pulse.trackPageView({
        object: {
            type: 'MarketFrontpage',
        },
        vertical: {
            name: market,
        },
    });

    tracking.trackPage({});

    if (navigator.serviceWorker) {
        navigator.serviceWorker.register('/sw.js').catch(() => {});
    }

    trackClick('[data-tracking-id="new-ad"]', () => {
        tracking.trackEventLater({
            analyticsName: 'new-ad.create-new-ad.marketpage',
            eventKpi: 'effect',
            stringValue: market,
        });

        pulse.trackEvent({
            type: 'Click',
            intent: 'Create',
            name: 'New ad',
            object: {
                id: 'new-ad-btn',
                type: 'UIElement',
                elementType: 'Button',
            },
            target: {
                id: '/innfinn',
                type: 'Page',
                pageType: 'ad_insertion',
            },
        });
    });

    trackClick('[data-tracking-id="new-c2b-entry"]', () => {
        tracking.trackEventLater({
            analyticsName: 'navigation.go-to-recommendations.bap-browse',
            stringValue: market,
        });
    });

    clickEventClosest('[data-link-id="bap-all"]');
    clickEventClosest('[data-link-id="bap-free"]');
    addBraze();
}

main();
